import {
  exQue,
  //, exMut
} from "@/utils/gql";
import { FIND_INDICADORES } from "../../../apollo/queries.js";
export default {
  namespaced: true,
  state: {
    indicadores: {
      1: {
        id: 1,
        titulo: "Chile",
        opciones: [],
      },
      2: {
        id: 2,
        titulo: "Perzonalizado",
        opciones: [],
      },
    },
  },
  mutations: {
    SET_INDICADORES(state, ind) {
      if (Array.isArray(ind)) {
        const indic = ind.reduce((acc, item) => {
          const newOpt = item.opciones.map((opcion) => {
            opcion.nombre_nuevo = `${opcion.nombre_indicador} (${opcion.nombre_completo})`;
            opcion.nombre_valor = `${opcion.nombre_indicador}:  ${opcion.valor} ${opcion.simbolo} (${opcion.nombre_completo})`;
            return opcion;
          });
          acc[item.id] = { ...item, opciones: newOpt };
          return acc;
        }, {});
        state.indicadores = { ...state.indicadores, ...indic };
      }
    },
  },
  actions: {
    async fetchIndicadores({ commit }) {
      const data = await exQue(FIND_INDICADORES);
      commit("SET_INDICADORES", data);
    },
  },
};
